import classNames from "classnames";
import styles from "./style.module.scss";

interface CustomCheckboxProps {
  label?: string | any;
  filtersCheckbox?: any;
  type?: string;
  name?: string;
  checked?: boolean;
  onChange?: () => void;
  labelClass?: string;
}

const CustomCheckbox = ({
  label,
  filtersCheckbox,
  type = "checkbox",
  name,
  checked = false,
  onChange,
  labelClass,
}: CustomCheckboxProps) => {
  const inputId = `${name}-${label}`;

  return (
    <div className={classNames(styles.checkboxContainer, filtersCheckbox)}>
      <input
        id={inputId}
        name={name}
        type={type}
        checked={checked}
        onChange={onChange}
      />
      <label
        htmlFor={inputId}
        className={classNames(styles.labelClass, labelClass)}
      >
        {label}
      </label>
    </div>
  );
};

export default CustomCheckbox;
